import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useMatch } from 'react-router-dom'

const useSetDefaultStateSNCManageSearch = () => {
  const dispatch = useDispatch();

  // 契約会社管理
  const matchSNCCompany = useMatch("/app/snc-admin/company/");
  const matchSNCCompanyDetail = useMatch("/app/snc-admin/company/register/");
  // 管理アカウント
  const matchSNCUser = useMatch("/app/snc-admin/user/");
  const matchSNCUserDetail = useMatch("/app/snc-admin/user/register/");
  // システム管理
  const matchSNCSystem = useMatch("/app/snc-admin/system/");
  const matchSNCSystemDetail = useMatch("/app/snc-admin/system/register/");
  // ストア管理
  const matchSNCStore = useMatch("/app/snc-admin/store/");
  const matchSNCStoreDetail = useMatch("/app/snc-admin/store/register/");
  // 書式管理-地域設定管理
  const matchLocalConfigManage = useMatch("/app/local-config-manage/");
  const matchLocalConfigManageDetail = useMatch("/app/snc-admin/local-config-manage/admin/location-edit/");
  // 書式管理-契約会社地域管理
  const matchSNCAdminCompany = useMatch("/app/snc-admin/local-config-manage/admin/campany/");
  const matchSNCAdminCompanyDetail = useMatch("/app/snc-admin/local-config-manage/admin/campany/setting/");
  // ANDESニュース
  const matchANDESNews = useMatch("/app/snc-admin/news-manageAndes/");
  const matchANDESNewsDetail = useMatch("/app/snc-admin/news-manage/registerAndes/");
  // CADEWAニュース
  const matchCADEWANews = useMatch("/app/snc-admin/news-manage/");
  const matchCADEWANewsDetail = useMatch("/app/snc-admin/news-manage/register/");

  useEffect(() => {
    // 契約会社管理
    if (!matchSNCCompany && !matchSNCCompanyDetail) {
      sessionStorage.removeItem("/app/snc-admin/company_searchConditions");
      sessionStorage.removeItem("/app/snc-admin/company/register_searchConditions");
    }

    // 管理アカウント
    if (!matchSNCUser && !matchSNCUserDetail) {
      sessionStorage.removeItem("/app/snc-admin/user_searchConditions");
      sessionStorage.removeItem("/app/snc-admin/user/register_searchConditions");
    }

    // システム管理
    if (!matchSNCSystem && !matchSNCSystemDetail) {
      sessionStorage.removeItem("/app/snc-admin/system_searchConditions");
      sessionStorage.removeItem("/app/snc-admin/system/register_searchConditions");
    }

    // ストア管理
    if (!matchSNCStore && !matchSNCStoreDetail) {
      sessionStorage.removeItem("/app/snc-admin/store_searchConditions");
      sessionStorage.removeItem("/app/snc-admin/store/register_searchConditions");
    }

    // 書式管理-地域設定管理
    if (!matchLocalConfigManage && !matchLocalConfigManageDetail) {
      sessionStorage.removeItem("/app/local-config-manage_searchConditions");
      sessionStorage.removeItem("/app/local-config-manage/register_searchConditions");
    }

    // 書式管理-契約会社地域管理
    if (!matchSNCAdminCompany && !matchSNCAdminCompanyDetail) {
      sessionStorage.removeItem("/app/snc-admin/local-config-manage/admin/campany_searchConditions");
      sessionStorage.removeItem("/app/snc-admin/local-config-manage/admin/campany/register_searchConditions");
    }
    
    // ANDESニュース
    if (!matchANDESNews && !matchANDESNewsDetail) {
      sessionStorage.removeItem("/app/snc-admin/news-manageAndes_searchConditions");
      sessionStorage.removeItem("/app/snc-admin/news-manageAndes/registerAndes_searchConditions");
    }
    
    // CADEWAニュース
    if (!matchCADEWANews && !matchCADEWANewsDetail) {
      sessionStorage.removeItem("/app/snc-admin/news-manage_searchConditions");
      sessionStorage.removeItem("/app/snc-admin/news-manage/register_searchConditions");
    }
  }, [
    dispatch,
    matchSNCCompany, matchSNCCompanyDetail,
    matchSNCUser, matchSNCUserDetail,
    matchSNCSystem, matchSNCSystemDetail,
    matchSNCStore, matchSNCStoreDetail,
    matchLocalConfigManage, matchLocalConfigManageDetail,
    matchSNCAdminCompany, matchSNCAdminCompanyDetail,
    matchANDESNews, matchANDESNewsDetail,
    matchCADEWANews, matchCADEWANewsDetail
  ]);
};

export default useSetDefaultStateSNCManageSearch;
